"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Splits5 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var bricks_1 = require("../../bricks");
var placeholder = [
    {
        image: 'https://picsum.photos/seed/edrftg/500/900',
        heading: 'Tum dicere exorsus',
        paragraph: 'Ut placet inquam tum dicere exorsus est laborum et dolorem aspernari ut enim ipsam esse appetendum alterum aspernandum sentiamus alii autem',
    },
    {
        image: 'https://picsum.photos/seed/poikjmn/500/900',
        heading: 'At veritas',
        paragraph: 'Torquatos nostros quos dolores suscipiantur maiorum voluptatum deleniti atque natum aspernatur aut contra sit a sapiente delectus mutium summo bono',
    },
    {
        image: 'https://picsum.photos/seed/zxcvzo/500/900',
        heading: 'Filium morte si quos',
        paragraph: 'Alii autem quibus ego teneam sententiam quid fiestio eligendio optio umque nihil molestiae non recusandae itaque earum rerum necessitatibus saepes',
    },
];
// todo: add video?
var Splits5 = function () { return ((0, jsx_runtime_1.jsx)("section", { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container-fluid" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "row g-0 splits-5-row" }, { children: placeholder.map(function (item, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col-lg-4 overlay overlay-scrim-blue" }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: "#", className: "d-block text-dark h-100 splits-5-anchor" }, { children: [(0, jsx_runtime_1.jsx)(bricks_1.BackgroundImage, { src: item.image }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "position-relative z-2 h-100 d-flex flex-column align-items-end" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "mt-auto p-6 p-sm-7 p-xl-10" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "row" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "col-md-8 col-lg-12" }, { children: [(0, jsx_runtime_1.jsx)(bricks_1.VideoPlayCircle, { size: "sm", inline: true, className: "mb-6" }), (0, jsx_runtime_1.jsx)("h2", __assign({ className: "h1 lh-1-5 mb-4" }, { children: item.heading })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "lead opacity-100 lh-1-75 mb-0" }, { children: item.paragraph }))] })) })) })) }))] })) }), index)); }) })) })) })); };
exports.Splits5 = Splits5;
